import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Banner from '../../Banner';

const SingleSlideLayout = ({
  adZone,
  banner,
  mobileSquareMode,
  onVideoPlaybackChange,
  onVisible,
  isPortraitVideoSlide,
  slideWidth,
  variableWidth,
}) => {
  useEffect(() => {
    onVisible?.();
  }, [onVisible]);

  return (
    <div className="BannerSlider__single-slide-layout">
      <div
        className={classNames('BannerSlider__slide', {
          'BannerSlider__slide--mobile-letterbox': mobileSquareMode,
          'BannerSlider__slide--portrait-video':
            mobileSquareMode && isPortraitVideoSlide,
        })}
        style={variableWidth ? { width: slideWidth } : undefined}
      >
        <Banner
          banner={banner}
          bannerZone={adZone}
          onVideoPlaybackChange={onVideoPlaybackChange}
        />
      </div>
    </div>
  );
};

SingleSlideLayout.propTypes = {
  adZone: PropTypes.string.isRequired,
  banner: PropTypes.object.isRequired,
  mobileSquareMode: PropTypes.bool.isRequired,
  onVideoPlaybackChange: PropTypes.func.isRequired,
  onVisible: PropTypes.func,
  isPortraitVideoSlide: PropTypes.bool.isRequired,
  slideWidth: PropTypes.number,
  variableWidth: PropTypes.bool.isRequired,
};

export default SingleSlideLayout;
